export default "__VITE_ASSET__c9b212ed__"